import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  SchedulerCleningMappingRowType,
} from './Scheduler.types'
import { Box } from '@mui/material'

const dataConfig = {
  required: [
    'asset',
    'programName',
    'cip',
    'cipChannel',
    'prepTime',
    'preRinseTime',
    'causticTime',
    'finalRinseTime',
    'drainTime',
    'totalTargetTime',
  ],
  optional: [],
}
export const SchedulerCleningMappingTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<SchedulerCleningMappingRowType>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (
    changedRows: Record<number, SchedulerCleningMappingRowType>
  ) => {
    updateTableData(changedRows)
  }
  //Example data:
  // {
  //   asset: 'BBL01'
  //   causticTime: '1'
  //   cip: '1'
  //   cipChannel: '1'
  //   drainTime: '0'
  //   finalRinseTime: '1'
  //   id: 0
  //   preRinseTime: '1'
  //   prepTime: '0'
  //   programName: 'BBL01'
  //   totalTargetTime: '40'
  // }
  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        field: 'asset',
        headerName: 'Resource Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'programName',
        headerName: 'Program Name',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'cip',
        headerName: 'CIP',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'cipChannel',
        headerName: 'CIP Channel',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'prepTime',
        headerName: 'Prep Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'preRinseTime',
        headerName: 'Pre Rinse Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'causticTime',
        headerName: 'Caustic Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'finalRinseTime',
        headerName: 'Final Rinse Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'drainTime',
        headerName: 'Drain Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'totalTargetTime',
        headerName: 'Total Target Time',
        flex: 1,
        editable: true,
        type: 'number',
      },
    ],
    [data]
  )

  return (
    <Box>
      <BaseTable
        // Each user's saved view of this table (Save as my default).
        layoutKey="CleaningMapping"
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerCleaningMapping"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
